import { FC } from "react";

interface MainContentProps {
	fullHeight?: boolean;
	children: React.ReactNode;
	className?: string;
}

const MainContent: FC<MainContentProps> = ({
	fullHeight,
	className,
	children,
}: MainContentProps) => {
	return (
		<div
			className={`${fullHeight ? "h-[75vh]" : "h-[65vh]"
				} px-[1.5%] py-[2vh] ${className}`}
		>
			<div className="h-[85%]">{children}</div>
		</div>
	);
};

export default MainContent;
